import { Card, Form } from "antd";
import { useTranslation } from "react-i18next";
import ActionButton from "../../../../../common/components/buttons/ActionButton";
import { OrderDirection } from "../../../../../common/enums";
import { ContractOrderByColumn, ContractView } from "../../../enums";
import { ContractFilterPageRequest } from "../../../types";
import { ContractFilterForm } from "../../forms/ContractFilterForm";

type Props = {
  validatedSearchParams?: ContractFilterPageRequest;
  updateSearchParams: (searchParams: ContractFilterPageRequest, append?: boolean, replace?: boolean) => void;
};

export const ContractUnpaidListFilterView = ({ validatedSearchParams, updateSearchParams }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<ContractFilterPageRequest>();

  const handleFilterClear = () => {
    form.resetFields();
    updateSearchParams(form.getFieldsValue(), false, true);
  };

  return (
    <>
      <Card
        className="card-box"
        title={<h2>{t("contract.titles.list")}</h2>}
        extra={
          <ActionButton color="danger" size="middle" variant="outlined" icon="reload" onClick={handleFilterClear}>
            {t("common.resetFilter")}
          </ActionButton>
        }
      >
        <ContractFilterForm
          form={form}
          report={ContractView.INTERNAL_UNPAID_REPORT}
          orderBy={[ContractOrderByColumn.CREATED_AT]}
          orderDirections={[OrderDirection.DESC]}
          updateSearchParams={updateSearchParams}
          validatedSearchParams={validatedSearchParams}
        />
      </Card>
    </>
  );
};
